import {
    CreditCardFilled,
    ExclamationCircleFilled,
    FilePdfFilled,
    FileProtectOutlined,
    PlusOutlined,
    SwapOutlined,
} from "@ant-design/icons";
import {
    Button,
    Col,
    ConfigProvider,
    DatePicker,
    Form,
    Input,
    Modal,
    Row,
    Select,
    Slider,
    Space,
    Spin,
    Switch,
    Table,
    Tag,
} from "antd";
import { Footer } from "antd/es/layout/layout";
import frFR from "antd/locale/fr_FR";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar";
import { rightsService } from "../../../services/rightsService";
import axiosInstance from "../../../variables/api/axiosInstance";
import { LOGGED_USER } from "../../../variables/constants";
import {
    frenchDate,
    frenchDateSimple,
} from "../../../variables/functions";
import AttestationMoto from "../components/docs/AttestationMoto";
import AttestationMotoToPrint from "../components/docs/AttestationMotoToPrint";
import DTRFFormat from "../components/docs/DTRFFormat";
import { displayNumbers } from "../../../variables/numbersFunctions";
import { StatCard } from "../../../components/statistics/StatCard";
import { COLORS } from "../../../components/ui/colors";

const { confirm } = Modal;
const { Option } = Select;
const { RangePicker } = DatePicker;

const dateFormat = "DD/MM/YYYY";

const Contrats = () => {
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [data, setData] = useState([]);
    const [selecting, setSelecting] = useState(false);
    const [hidden, setHidden] = useState(false);
    const [selectedContrats, setSelectedContrats] = useState([]);
    const [loadingContrats, setLoadingContrats] = useState(true);
    const [loading, setLoading] = useState(false);
    const [membres, setMembres] = useState([]);
    const [filteredInfo, setFilteredInfo] = useState({});
    const [sortedInfo, setSortedInfo] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [numAttestationModal, setNumAttestationModal] = useState(false);
    const [printingAttestation, setPrintingAttestation] = useState(false);
    const [numeroAttestations, setNumeroAttestations] = useState([]);
    const [modalModePaiement, setModalModePaiement] = useState(false);
    const [numeroPaiement, setNumeroPaiement] = useState("P");
    const [modePaiement, setModePaiement] = useState("");
    const [contractsToPay, setContractsToPay] = useState([]);
    const [contractToPay, setContractToPay] = useState();
    const [modePaiementForm] = Form.useForm();
    const [transferForm] = Form.useForm();
    const [banques, setBanques] = useState([]);
    const [banque, setBanque] = useState("BANQUE");
    const [currentContractIndex, setCurrentContractIndex] = useState(0);
    const [count, setCount] = useState("");

    const [transferModalVisible, setTransferModalVisible] = useState(false);
    const [transferLoading, setTransferLoading] = useState(false);

    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedCompagnies, setSelectedCompagnies] = useState([]);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, showSizeChanger: true });

    const [columns, setColumns] = useState([
        {
            title: "Numero de police",
            dataIndex: "numeroPolice",
            key: "1",
        },
        {
            title: "Souscripteur",
            dataIndex: "souscripteur",
            key: "2",
        },
        {
            title: "Organisme",
            dataIndex: "organisme",
            key: "3",
        },
        {
            title: "Date Effet",
            dataIndex: "dateEffet",
            key: "4",
        },
        {
            title: "Date Echeance",
            dataIndex: "dateEcheance",
            key: "5",
        },
        {
            title: "Statut reg.",
            dataIndex: "regle",
            key: "regle",
            render: (_, record) => (
                <>
                    {record.regle === "REGLE" ? (
                        <Tag color="success" key={_}>
                            REGLE
                        </Tag>
                    ) : (
                        <Tag color="blue" key={_}>
                            NON REGLE
                        </Tag>
                    )}
                </>
            ),
            filters: [
                {
                    text: "REGLE",
                    value: "REGLE",
                },
                {
                    text: "NON REGLE",
                    value: "NON REGLE",
                },
            ],
            filteredValue: filteredInfo.regle || null,
            onFilter: (value, record) => record.regle === value,
            sorter: (a, b) => a.regle.length - b.regle.length,
            sortOrder: sortedInfo.columnKey === "regle" ? sortedInfo.order : null,
            ellipsis: true,
        },
        {
            title: "Prime nette",
            dataIndex: "primeNette",
            key: "primeNette",
        },
        {
            title: "Accessoires",
            dataIndex: "accessoires",
            key: "accessoires",
        },
        {
            title: "Taxes",
            dataIndex: "taxes",
            key: "taxes",
        },
        {
            title: "Prime TTC",
            dataIndex: "primeTotale",
            key: "primeTotale",
        },
        Table.EXPAND_COLUMN,
        {
            title: "Actions",
            dataIndex: "actions",
            key: "7",
            render: (_, record) => (
                <>
                    <button
                        type="button"
                        class="btn btn-primary btn-icon rounded-pill"
                        onClick={() => navigate(`/details-contrat/${record.codeId}`)}
                    >
                        <i class="bx bx-dots-vertical-rounded"></i>
                    </button>
                </>
            ),
        },
    ]);

    const printRef = useRef();

    const navigate = useNavigate();

    const handleChange = (pagination, filters, sorter) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);
        setPagination(pagination);
        setFilteredInfo(filters);
        setSortedInfo(sorter);
    };

    const handleDateChange = (dates, dateStrings) => {
        const [sDate, eDate] = dateStrings;
        console.log(dateStrings);
        const [startDay, startMonth, startYear] = sDate.split("/");
        const [endDay, endMonth, endYear] = eDate.split("/");
        const startDate = `${startYear}-${startMonth}-${startDay}`;
        const endDate = `${endYear}-${endMonth}-${endDay}`;
        console.table([startDate, endDate]);
        setSelectedDate([startDate, endDate]);
        setFilteredInfo({
            ...filteredInfo,
            startDate,
            endDate,
        });
        fetchData({
            pagination,
            filters: {
                ...filteredInfo,
                startDate,
                endDate,
            },
        });
    };

    const fetchData = async (params = {}) => {
        setLoadingContrats(true);
        try {
            const response = await axiosInstance.get("/api/contrat/current", {
                params: {
                    page: params.pagination.current - 1,
                    size: params.pagination.pageSize,
                    ...params.filters,
                    compagnie: params.filters?.compagnie?.join(','),  // join the compagnies with `&compagnie=`
                },
            });
            const { content, totalElements } = response.data;
            // console.log("Total element; ", totalElements);
            // console.log(" element; ", content);
            let ctrs = [];
            content.forEach((contrat, key) => {
                ctrs.push({
                    key: contrat.codeId,
                    codeId: contrat.codeId,
                    id: key,
                    numeroPolice: contrat.numeroPoliceM
                        ? contrat.numeroPoliceM
                        : contrat.numeroPoliceP,
                    souscripteur: contrat?.prenom
                        ? `${contrat?.prenom} ${contrat?.nom}`
                        : `${contrat?.nom}`,
                    organisme: contrat?.raisonSociale,
                    dateEffet: contrat?.dateEffet
                        ? `${frenchDate(contrat?.dateEffet)}`
                        : "",
                    dateEcheance: contrat?.dateEcheance
                        ? `${frenchDateSimple(contrat?.dateEcheance)} `
                        : "",
                    regle: contrat.reglements
                        ? contrat.reglements
                            ? "REGLE"
                            : "NON REGLE"
                        : "NON REGLE",
                    primeTotale: displayNumbers(contrat?.primeTotale),
                    taxes: displayNumbers(contrat?.primeTotale * 0.06 / 1.06),
                    primeNette: displayNumbers(contrat?.primeNette),
                    accessoires: displayNumbers(contrat?.accessoires),
                    data: contrat,
                });
            });
            setData(ctrs);
            setPagination({
                ...params.pagination,
                total: totalElements,
            });
            setTotal(totalElements);
        } catch (error) {
            console.error("Failed to fetch data:", error);
        } finally {
            setLoadingContrats(false);
        }
    };

    const getContratOrganismeId = (contrat) => {
        if (!contrat) {
            return null;
        }

        if (contrat.organisme) {
            return contrat.organisme;
        }

        return null;
    };

    const reloadContrats = () => {
        const filtersPayload = { ...filteredInfo };

        if (selectedDate) {
            filtersPayload.startDate = selectedDate[0];
            filtersPayload.endDate = selectedDate[1];
        }

        if (selectedCompagnies?.length) {
            filtersPayload.compagnie = selectedCompagnies;
        }

        fetchData({
            pagination,
            filters: filtersPayload,
        });
    };

    const handleOpenTransferModal = () => {
        if (!selectedRows.length) {
            toast.info("Sélectionnez au moins un contrat à transférer.");
            return;
        }
        transferForm.resetFields();
        setTransferModalVisible(true);
    };

    const handleTransferCancel = () => {
        transferForm.resetFields();
        setTransferModalVisible(false);
    };

    const handleTransferSubmit = async () => {
        try {
            setTransferLoading(true);
            const values = await transferForm.validateFields();
            const targetOrganismeId = Number(values.targetOrganismeId);
            const motif = values.motif ? values.motif.trim() || null : null;

            const payloads = selectedRows.map((row) => ({
                contratCodeId: row.codeId,
                targetOrganismeId,
                motif,
            }));

            for (const payload of payloads) {
                await axiosInstance.post(`/api/contrat/transfer`, payload);
            }

            toast.success(
                payloads.length > 1
                    ? "Contrats transférés avec succès"
                    : "Contrat transféré avec succès",
            );
            setTransferModalVisible(false);
            transferForm.resetFields();
            setSelectedRowKeys([]);
            setSelectedRows([]);
            reloadContrats();
        } catch (error) {
            if (error?.errorFields) {
                return;
            }
            console.error("Failed to transfer contract(s):", error);
            toast.error("Erreur lors du transfert du contrat");
        } finally {
            setTransferLoading(false);
        }
    };

    const exportDataToExcel = async () => {
        if (selectedDate) {
            setLoadingContrats(true);
            const startDate = selectedDate[0];
            const endDate = selectedDate[1];
            const response = await axiosInstance.get("/api/contrat/all", {
                params: {
                    startDate,
                    endDate,
                    compagnie: selectedCompagnies?.join(','),  // join the compagnies with `&compagnie=`
                },
            });
            console.log("ok: ", response?.data);
            generateExcelFileFromArray(response?.data);
            setLoadingContrats(false);
        } else {
            toast("Veuillez sélectionner une période!");
        }
    }

    useEffect(() => {
        // fetchContracts(currentPage, pageSize, "", selectedDate, selectedCompagnie);
        if (selectedDate || selectedCompagnies) {
            if (selectedDate) {
                const startDate = selectedDate[0];
                const endDate = selectedDate[1];
                fetchData({
                    pagination,
                    filters: {
                        ...filteredInfo,
                        startDate,
                        endDate,
                        compagnie: selectedCompagnies
                    },
                });
            } else {
                fetchData({
                    pagination,
                    filters: {
                        ...filteredInfo,
                        compagnie: selectedCompagnies
                    },
                });
            }

        } else {
            fetchData({
                pagination,
                filteredInfo,
            });
        }

        axiosInstance
            .get(`/api/parametre/type/BANQUE`)
            .then((res) => {
                setBanques(res.data);
            })
            .catch((err) => {
                console.log(err);
            });

        if (LOGGED_USER?.agence?.typeAgence === "COURTIER") {
            const validAgreements = Array.isArray(LOGGED_USER?.agence?.validAgrements)
                ? LOGGED_USER.agence.validAgrements
                : [];
            const courtierCompanies = validAgreements
                .map((agreement, index) => {
                    const company = agreement?.compagnie;

                    if (!company?.organismeId) {
                        return null;
                    }

                    return {
                        key: company.organismeId || index,
                        text: company.raisonSociale,
                        value: company.code,
                        data: company,
                    };
                })
                .filter(Boolean);

            setMembres(courtierCompanies);
        } else {
            axiosInstance
                .get(`/api/organisme/assurance`)
                .then((res) => {
                    let membs = [];
                    res.data.forEach((memb, index) => {
                        membs.push({
                            key: index,
                            text: memb.raisonSociale,
                            value: memb.code,
                            data: memb,
                        });
                    });
                    membs.push({
                        key: "DTRF",
                        text: "DTRF",
                        value: "DTRF",
                    });
                    membs.push({
                        key: "DTRF-Lome",
                        text: "DTRF-LOME",
                        value: "LOME",
                    });
                    membs.push({
                        key: "DTRF-Kpalime",
                        text: "DTRF-KPALIME",
                        value: "KPALIME",
                    });
                    membs.push({
                        key: "DTRF-Atakpame",
                        text: "DTRF-ATAKPAME",
                        value: "ATAKPAME",
                    });
                    membs.push({
                        key: "DTRF-Sokode",
                        text: "DTRF-SOKODE",
                        value: "SOKODE",
                    });
                    membs.push({
                        key: "DTRF-Kara",
                        text: "DTRF-KARA",
                        value: "KARA",
                    });
                    membs.push({
                        key: "DTRF-Dapaong",
                        text: "DTRF-DAPAONG",
                        value: "DAPAONG",
                    });
                    membs.push({
                        key: "STCA",
                        text: "STCA",
                        value: "STCA",
                    });
                    setMembres(membs);
                })
                .catch((err) => {
                    console.log(err);
                });
        }

        axiosInstance
            .get(`/api/contrat/count`)
            .then((res) => {
                console.log("Count: ", res.data);
                setCount(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [loading, currentPage, pageSize, selectedDate]);

    const filteringOnCompanies = (companies) => {
        setSelectedCompagnies(companies);
        console.log(companies);
        setFilteredInfo({
            ...filteredInfo,
            compagnie: companies
        });
        fetchData({
            pagination,
            filters: {
                ...filteredInfo,
                compagnie: companies
            },
        });
    };

    const attestationRefs = useRef(selectedContrats.map(() => React.createRef()));
    const printedAttestationRefs = useRef(
        selectedContrats.map(() => React.createRef()),
    );

    const MyFooter = () => {
        let ctrt = selectedRows.find((ctr) => ctr.regle === "NON REGLE");
        let rCtrts = selectedRows.filter((ctr) => ctr.regle === "REGLE");
        let nrCtrts = selectedRows.filter((ctr) => ctr.regle === "NON REGLE");
        // console.log("R: ", rCtrts);
        // console.log("NR: ", nrCtrts);
        return (
            <div class="row">
                {ctrt ? (
                    <div class="col-sm-4">
                        <Button
                            onClick={() => {
                                encaisserContrats(nrCtrts);
                            }}
                            color="success"
                            icon={<CreditCardFilled />}
                            style={{
                                color: "red",
                            }}
                            title="Encaissement"
                        >
                            Encaisser
                        </Button>
                    </div>
                ) : (
                    <>
                        <div class="col-sm-4">
                            <Button
                                onClick={() => {
                                    exportToPdfs(rCtrts);
                                }}
                                color="primary"
                                style={{ color: "green" }}
                                icon={<FilePdfFilled />}
                            >
                                Imprimer C.P.
                            </Button>
                        </div>
                        <div class="col-sm-4">
                            <Button
                                onClick={() => {
                                    exportAttestations(rCtrts);
                                }}
                                color="primary"
                                style={{ color: "blue" }}
                                icon={<FileProtectOutlined />}
                            >
                                Imprimer Attestation
                            </Button>
                        </div>
                    </>
                )}
                <div class="col-sm-4">
                    <Button
                        type="primary"
                        icon={<SwapOutlined />}
                        style={{ background: "#fa8c16", borderColor: "#fa8c16" }}
                        disabled={!selectedRows.length}
                        loading={transferLoading}
                        onClick={handleOpenTransferModal}
                    >
                        Transférer
                    </Button>
                </div>
            </div>
        );
    };


    const encaisserContrats = (cts) => {
        setModalModePaiement(true);
        setContractsToPay(cts);
    };

    const encaisserContrat = (id) => {
        setModalModePaiement(true);
        setContractToPay(id);
    };

    const alertReglement = (contractToPay) => {
        // console.log(numeroPaiement);
        confirm({
            title: "Etes-vous sûr de vouloir régler ce contrat?",
            icon: <ExclamationCircleFilled />,
            content: "Toutes vos actions sont historisées!",
            okText: "Oui régler",
            okType: "danger",
            cancelText: "Annuler",
            onOk() {
                console.log("OK");
                reglementContrat(contractToPay);
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    };

    const reglementContrat = (id) => {
        if (modePaiement === "ESPECES") {
            axiosInstance
                .get(
                    `/api/reglement/especes/contrat/codeId/${id}/${LOGGED_USER.codeId}`,
                )
                .then((res) => {
                    window.location.reload();
                    toast("Reglement effectué avec succès!");
                    // console.log(res.data);
                })
                .catch((err) => {
                    console.log(err);
                    toast("Erreur lors du règlement");
                });
        } else if (modePaiement === "BANQUE" || modePaiement === "MOBILE_MONEY") {
            axiosInstance
                .get(
                    `/api/reglement/contrat/codeId/${id}/${LOGGED_USER.codeId}/${modePaiement}/${numeroPaiement}/${banque}`,
                )
                .then((res) => {
                    window.location.reload();
                    toast("Règlement effectué avec succès!");
                    // console.log(res.data);
                    res.data = null;
                })
                .catch((err) => {
                    console.log(err);
                    toast("Erreur lors du règlement");
                });
        }
    };

    const alertReglements = (cts) => {
        // console.log(numeroPaiement);
        confirm({
            title: "Etes-vous sûr de vouloir régler ces contrats?",
            icon: <ExclamationCircleFilled />,
            content: "Toutes vos actions sont historisées!",
            okText: "Oui régler",
            okType: "danger",
            cancelText: "Annuler",
            onOk() {
                console.log("OK");
                reglementsContrats(cts);
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    };

    const reglementsContrats = (contrats) => {
        var allContrats = [];
        contrats.forEach((ctrt) => {
            allContrats.push(ctrt.data);
        });
        // console.log("Contrats: ", allContrats);
        if (modePaiement === "ESPECES") {
            axiosInstance
                .post(`/api/reglement/especes/contrats`, JSON.stringify(allContrats))
                .then((res) => {
                    // setLoadingContrats(true);
                    window.location.reload();
                    toast("Règlements effectués avec succès!");
                    // console.log(res.data);
                })
                .catch((err) => {
                    console.log(err);
                    toast("Erreur lors du règlement");
                });
        } else if (modePaiement === "BANQUE" || modePaiement === "MOBILE_MONEY") {
            axiosInstance
                .post(
                    `/api/reglement/else/${modePaiement}/${numeroPaiement}/${banque}`,
                    JSON.stringify(allContrats),
                )
                .then((res) => {
                    // setLoadingContrats(true);
                    window.location.reload();
                    toast("Règlements effectués avec succès!");
                    // console.log(res.data);
                })
                .catch((err) => {
                    console.log(err);
                    toast("Erreur lors du règlement");
                });
        }
    };

    const exportAttestations = (contrats) => {
        // setPrintingAttestation(true);
        setNumAttestationModal(true);
        setSelectedContrats(contrats);
        // console.log("Contrats: ", contrats);
        // console.log(numeroAttestations);
    };

    const attestationPrinting = () => {
        // console.log("update printing");
        selectedContrats.forEach((aContrat, index) => {
            exportAttestationToPdf();
            // console.log(aContrat, " gooddd ", index);
        });
    };

    const exportAttestationToPdf = useReactToPrint({
        content: () => attestationRefs.current[currentContractIndex]?.current,
        onBeforeGetContent: () => setPrintingAttestation(false),
        onAfterPrint: () => {
            // Move to the next contract after the current one is printed
            setCurrentContractIndex((prevIndex) => prevIndex + 1);
        },
    });

    useEffect(() => {
        if (currentContractIndex < selectedContrats.length) {
            // Trigger the print for the next contract
            exportAttestationToPdf();
        } else {
            // Reset once all contracts have been printed
            setCurrentContractIndex(0);
        }
    }, [currentContractIndex]);

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    });

    const exportToPdfs = (contrats) => {
        setSelectedContrats(contrats);
        // console.log("Contrats: ", contrats);
        setHidden(true);
        setTimeout(() => {
            handlePrint();
            contrats.forEach((ctrt) => {
                axiosInstance
                    .get(
                        `/api/contrat/impression/codeId/${ctrt.codeId}/${LOGGED_USER.codeId}`,
                    )
                    .then((res) => {
                        // console.log(res.data);
                        console.log("OK");
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            });
        }, [500]);
    };

    const onSelectChange = (newSelectedRowKeys, rows) => {
        // console.log("selectedRowKeys changed: ", newSelectedRowKeys);
        // console.log("SelectedRows", rows);
        setSelectedRows(rows);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const pbStyles = {
        pageBreak: {
            pageBreakBefore: "always",
        },
    };

    const selectedOrganismeIds = Array.from(
        new Set(
            selectedRows
                .map((row) => getContratOrganismeId(row?.data)),
        ),
    );

    const remainingCompanies = membres?.filter((membre) => !selectedRows.find((row) => row?.organisme === membre.text))

    // console.log("selectedOrganismeIds", selectedOrganismeIds, selectedRows, remainingCompanies, membres);

    const generateExcelFileFromArray = (array, fileName = "ListingPolices") => {
        const headers = ['N° Police', 'Immatriculation', 'Assuré', 'Date effet', 'Date échéance', 'Prime nette', 'Accessoires', 'Taxes', 'Prime TTC', 'Prime à reporter'];
        const keyMapping = { 'N° Police': 'numeroPoliceP', 'Immatriculation': 'immatriculation', 'Assuré': 'contrat.souscripteur.nom', 'Date effet': 'dateEffet', 'Date échéance': 'dateEcheance', 'Prime nette': 'primeNette', 'Accessoires': 'accessoires', Taxes: 'taxes', 'Prime TTC': 'primeTotale', 'Prime à reporter': 'prec' };
        const mappedData = array.map(item => {
            const newItem = {};
            for (let key of headers) {
                // console.log("item", item.contrat);
                // console.log("key", key);
                if (key === "Taxes") {
                    newItem[key] = Math.floor(item?.primeTotale * 0.06 / 1.06);
                } else if (key === "Prime TTC") {
                    newItem[key] = Math.floor(item?.primeTotale);
                } else if (key === "Accessoires") {
                    newItem[key] = Math.floor(item?.accessoires);
                } else if (key === "Prime à reporter") {
                    newItem[key] = Math.floor(item?.prec);
                } else if (key === "Prime nette") {
                    newItem[key] = Math.floor(item?.primeNette);
                } else if (key === "Assuré") {
                    newItem[key] = item?.souscripteur?.nom + `${item?.souscripteur?.prenom ? item?.souscripteur?.prenom : ""}`;
                } else if (key === "N° Police") {
                    newItem[key] = item?.numeroPoliceP;
                } else if (key === "Immatriculation") {
                    newItem[key] = item?.engins ? item?.engins[0]?.immatriculation : "";
                } else {
                    newItem[key] = item[keyMapping[key]];
                }
            }
            return newItem;
        });
        const worksheet = XLSX.utils.json_to_sheet(mappedData, { header: headers });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, `${fileName}.xlsx`);
    }


    return (
        <div class="layout-wrapper layout-content-navbar  ">
            <div class="layout-container">
                <SideBar currentMenu={"PRODUCTION"} />

                {/* <!-- Layout container --> */}
                <div class="layout-page">
                    <NavBar />

                    {/* <!-- Content wrapper --> */}
                    <div class="content-wrapper">
                        {/* <!-- Content --> */}
                        <div class="container-xxl flex-grow-1 container-p-y">
                            <Row style={{ marginBottom: "15px", justifyContent: "space-between" }}>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats"
                                        subtitle="Total contrats"
                                        value={displayNumbers(total || 0)}
                                        icon="bx bx-file"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats validés"
                                        subtitle="Nbre total actifs / Nbre total validés"
                                        value={`${count?.activeCount ? displayNumbers(count?.activeCount) : 0} / ${count?.valideCount ? displayNumbers(count?.valideCount) : 0}`}
                                        icon="bx bx-check-circle"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats annulés"
                                        subtitle="Contrats annulés"
                                        value={displayNumbers(count?.annuleCount || 0)}
                                        icon="bx bx-x-circle"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats en attente"
                                        subtitle="Contrats en Proposition"
                                        value={displayNumbers(count?.enPropositionCount || 0)}
                                        icon="bx bx-time-five"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                            </Row>
                            {/* <!-- Users List Table --> */}
                            <div class="row">
                                <div class="col-sm-4">
                                    {rightsService("HCO022") ||
                                        rightsService("HCO005") ||
                                        rightsService("HCO019") ? (
                                        <Button
                                            type="primary"
                                            icon={<PlusOutlined />}
                                            style={{ marginBottom: 16, backgroundColor: COLORS.secondary }}
                                            onClick={() => navigate("/ajouter-contrat-new")}
                                        >
                                            Nouveau contrat
                                        </Button>
                                    ) : null}
                                </div>
                                <div class="col-sm-4">
                                    {rightsService("HLA078") ? (
                                        <Button
                                            type="primary"
                                            icon={<PlusOutlined />}
                                            style={{ marginBottom: 16, background: "gray" }}
                                            onClick={() => navigate("/ancien-contrat-gum")}
                                        >
                                            Ajouter Ancien contrat GUM
                                        </Button>
                                    ) : null}
                                </div>
                                {/* <div class="col-sm-4">
                                    {rightsService("HLA036") ? (
                                        <Button
                                            type="primary"
                                            style={{
                                                background: "green",
                                                marginBottom: 16,
                                            }}
                                            icon={<ReloadOutlined />}
                                            loading={loading}
                                            onClick={() => {
                                                dtrfFilesLoad();
                                            }}
                                        >
                                            PREC
                                        </Button>
                                    ) : null}
                                </div> */}
                                {/* <div class="col-sm-4">
                                    {rightsService("HCO021") ? (
                                        <Button
                                            type="primary"
                                            icon={<UploadOutlined />}
                                            style={{
                                                background: "gray",
                                                marginBottom: 16,
                                            }}
                                            onClick={() => {
                                                navigate("/production/port");
                                            }}
                                        >
                                            Chargement - STAC
                                        </Button>
                                    ) : null}
                                </div> */}
                            </div>

                            <div class="card">
                                <div class="container">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-4">
                                                    <Space align="center" style={{ marginBottom: 16 }}>
                                                        Mode sélection:{" "}
                                                        <Switch
                                                            checked={selecting}
                                                            onChange={setSelecting}
                                                        />
                                                    </Space>
                                                </div>
                                                <div class="col-4">
                                                    <RangePicker
                                                        format={dateFormat}
                                                        onChange={handleDateChange}
                                                        placeholder="Filtre par date"
                                                    />
                                                    {/*<DatePicker*/}
                                                    {/*    onChange={dateFiltering}*/}
                                                    {/*    type="primary"*/}
                                                    {/*    icon={<CalendarOutlined/>}*/}
                                                    {/*    placeholder="Filtre par date"*/}
                                                    {/*/>*/}
                                                </div>
                                                {LOGGED_USER?.profil?.organisme?.typeOrganisme === "POOL" && (LOGGED_USER?.agence?.typeAgence === "SIEGE" || LOGGED_USER?.agence === null) ?
                                                    <div class="col-4">
                                                        <Select
                                                            mode="multiple"
                                                            placeholder="Filtre par compagnie"
                                                            onChange={filteringOnCompanies}
                                                            options={membres.map((memb) => (
                                                                {
                                                                    label: memb.text,
                                                                    value: memb.value,
                                                                    key: memb.value
                                                                }
                                                            ))}
                                                            style={{ width: "80%" }}
                                                        />
                                                    </div> : null}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ConfigProvider locale={frFR}>
                                    <Spin spinning={loadingContrats}>
                                        <Table
                                            rowSelection={selecting ? rowSelection : null}
                                            expandable={{
                                                expandedRowRender: (record) => {
                                                    const compteDebit = record.modePaiement === "ESPECE"
                                                        ? "540.00.11"
                                                        : record.modePaiement === "BANQUE"
                                                            ? "562.00.11"
                                                            : "571.00.11";
                                                    const montant = new Intl.NumberFormat("fr-FR").format(record.montant);
                                                    const police = record.numeroPolice;
                                                    const avenant = record?.avenant?.code || "AN";
                                                    const nom = record.contrat?.souscripteur?.nom;

                                                    return (
                                                        <div style={{ padding: "16px" }}>
                                                            <p><strong>Écriture comptable : Encaissement - N° Police: {police}</strong></p>
                                                            <table className="table table-bordered" style={{ width: "100%", marginBottom: "8px" }}>
                                                                <thead>
                                                                    <tr>
                                                                        <th colSpan={2}>COMPTES</th>
                                                                        <th></th>
                                                                        <th colSpan={2}>MONTANT</th>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>DEBIT</th>
                                                                        <th>CREDIT</th>
                                                                        <th>LIBELLE</th>
                                                                        <th>DEBIT</th>
                                                                        <th>CREDIT</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>{compteDebit}</td>
                                                                        <td></td>
                                                                        <td>Compte de trésorerie utilisé</td>
                                                                        <td>{montant}</td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td></td>
                                                                        <td>412.00.11</td>
                                                                        <td>Compte de prime en recouvrement du point de vente</td>
                                                                        <td></td>
                                                                        <td>{montant}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                            <p style={{ fontStyle: "italic" }}>
                                                                Encaissement & Pol N° {police} & Av N° {avenant} & {nom}
                                                            </p>
                                                        </div>
                                                    );
                                                },
                                            }}
                                            columns={columns}
                                            rowKey="codeId"
                                            dataSource={data}
                                            onChange={handleChange}
                                            pagination={pagination}
                                            footer={() => selecting ? <MyFooter /> : null}
                                        />
                                    </Spin>
                                </ConfigProvider>
                            </div>
                            <div class="card" id="myContrat" ref={printRef}>
                                {selecting &&
                                    hidden &&
                                    selectedContrats.map((row, index) => (
                                        <DTRFFormat contrat={row.data} key={index} />
                                    ))}
                            </div>
                        </div>
                        <Modal
                            title="Transférer vers une compagnie"
                            centered
                            open={transferModalVisible}
                            onOk={handleTransferSubmit}
                            onCancel={handleTransferCancel}
                            confirmLoading={transferLoading}
                            okText="Transférer"
                            cancelText="Annuler"
                        >
                            <p class="mb-3 text-muted">
                                {selectedRows.length > 1
                                    ? "Les contrats sélectionnés seront transférés vers la même compagnie. Les écritures comptables existantes seront supprimées automatiquement."
                                    : "Le contrat sera transféré vers la nouvelle compagnie. Les écritures comptables existantes seront supprimées automatiquement."
                                }
                            </p>
                            <Form form={transferForm} layout="vertical">
                                <Form.Item
                                    name="targetOrganismeId"
                                    label="Compagnie de destination"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Veuillez sélectionner la compagnie de destination",
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder="Sélectionnez la compagnie de destination"
                                        showSearch
                                        optionFilterProp="children"
                                    >
                                        {remainingCompanies
                                            .map((memb) => (
                                                <Option
                                                    key={memb?.data?.organismeId}
                                                    value={memb?.data?.organismeId}
                                                >
                                                    {memb?.data?.raisonSociale}
                                                </Option>
                                            ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item name="motif" label="Motif">
                                    <Input.TextArea
                                        rows={3}
                                        placeholder="Motif du transfert (optionnel)"
                                    />
                                </Form.Item>
                            </Form>
                        </Modal>
                        <Modal
                            title="Mode de paiement"
                            centered
                            open={modalModePaiement}
                            onOk={() => {
                                selecting
                                    ? alertReglements(contractsToPay)
                                    : alertReglement(contractToPay);
                            }}
                            onCancel={() => {
                                setModalModePaiement(false);
                            }}
                        >
                            <>
                                <div className="container" justify="center">
                                    <div className="grid-item" lg={12}>
                                        <Form
                                            form={modePaiementForm}
                                            layout="vertical"
                                            name="userForm"
                                        >
                                            <Form.Item
                                                name="modePaiement"
                                                label="Mode de paiement"
                                                rules={[
                                                    {
                                                        required: true,
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    onChange={(value) => {
                                                        // console.log(value);
                                                        setModePaiement(value);
                                                    }}
                                                    placeholder="Selectionnez votre mode de paiement"
                                                >
                                                    <Option value="ESPECES"> ESPECES </Option>
                                                    <Option value="BANQUE">BANQUE (Chèque)</Option>
                                                    <Option value="MOBILE_MONEY">TMONEY / FLOOZ</Option>
                                                </Select>
                                            </Form.Item>
                                            {modePaiement === "BANQUE" ||
                                                modePaiement === "MOBILE_MONEY" ? (
                                                <Form.Item
                                                    name="numeroPaiement"
                                                    label={
                                                        modePaiement === "BANQUE"
                                                            ? "Numero de chèque"
                                                            : modePaiement === "MOBILE_MONEY"
                                                                ? "Numero FLOOZ / TMONEY"
                                                                : ""
                                                    }
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "Veuillez renseigner le champ!",
                                                        },
                                                    ]}
                                                >
                                                    <Input
                                                        placeholder={
                                                            modePaiement === "BANQUE"
                                                                ? "Le numero de chèque"
                                                                : modePaiement === "MOBILE_MONEY"
                                                                    ? "Le numero de téléphone MOOV (FLOOZ) / TOGOCOM (TMONEY)"
                                                                    : ""
                                                        }
                                                        onChange={(value) => {
                                                            // console.log(value.target.value);
                                                            setNumeroPaiement(value.target.value);
                                                        }}
                                                    />
                                                </Form.Item>
                                            ) : null}
                                            {modePaiement === "BANQUE" ? (
                                                <Form.Item
                                                    name="banque"
                                                    label="Banque"
                                                    rules={[
                                                        {
                                                            required: true,
                                                        },
                                                    ]}
                                                >
                                                    <Select
                                                        onChange={(value) => {
                                                            // console.log(value);
                                                            setBanque(value);
                                                        }}
                                                        placeholder="Selectionnez la banque"
                                                    >
                                                        {banques.map((b) => (
                                                            <Option
                                                                key={b.parametreId}
                                                                value={b.libelleParametre}
                                                            >
                                                                {b.libelleParametre}
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>
                                            ) : null}
                                        </Form>
                                    </div>
                                </div>
                            </>
                        </Modal>
                        <Modal
                            title="Attestation"
                            centered
                            open={numAttestationModal}
                            onOk={() => {
                                // window.location.reload();
                                setNumAttestationModal(false);
                            }}
                            onCancel={() => {
                                // window.location.reload();
                                setNumAttestationModal(false);
                            }}
                            width={1200}
                            zIndex={2000}
                        >
                            <div className="container" justify="center">
                                <div className="grid-item" lg={12}>
                                    {selectedContrats.map((row, index) => (
                                        <div key={index}>
                                            <div>
                                                <AttestationMoto
                                                    ref={attestationRefs.current[index]}
                                                    contrat={row.data}
                                                    printing={
                                                        printingAttestation &&
                                                        currentContractIndex === index
                                                    }
                                                />
                                                <div style={{ display: "none" }}>
                                                    <AttestationMotoToPrint
                                                        ref={printedAttestationRefs.current[index]}
                                                        contrat={row.data}
                                                    />
                                                </div>

                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                            </div>
                                            <div style={pbStyles.pageBreak} className="pageBreak">
                                                <hr />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <>
                                Veuillez préciser les numéros d&apos;attestations à imprimer
                                <br />
                                <Slider
                                    range
                                    className="slider-main-div"
                                    min={10000}
                                    max={100000}
                                    onChange={(v) => {
                                        setNumeroAttestations(v);
                                        // console.log(v);
                                    }}
                                    defaultValue={[10000, 100000]}
                                    value={numeroAttestations}
                                />
                            </>
                            <br />
                            <br />
                            <Button
                                onClick={() => {
                                    // console.log("nA: ", numeroAttestations);
                                    attestationPrinting();
                                }}
                                type="primary"
                                style={{
                                    background: "green",
                                }}
                            >
                                Imprimer
                            </Button>
                        </Modal>
                        {/* <!-- / Content --> */}

                        {/* <!-- Footer --> */}
                        <Footer />
                        {/* <!-- / Footer --> */}

                        <div class="content-backdrop fade"></div>
                    </div>
                    {/* <!-- Content wrapper --> */}
                </div>
                {/* <!-- / Layout page --> */}
            </div>

            {/* <!-- Overlay --> */}
            <div class="layout-overlay layout-menu-toggle"></div>
            {rightsService("HCO021") ? (
                <Spin spinning={loadingContrats}>
                    <div class="buy-now">
                        <button
                            onClick={() => exportDataToExcel()}
                            class="btn btn-secondary btn-buy-now"
                        >
                            Exporter
                        </button>
                    </div>
                </Spin>
            ) : null}
            {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
            <div class="drag-target"></div>
        </div>
    );
};

export default Contrats;
